export const REMAININGS = {
  MEAN: "mean",
  MIN: "min",
  MAX: "max",
  STD: "std",
} as const;
